import script from "./UButton.vue?vue&type=script&setup=true&lang=js"
export * from "./UButton.vue?vue&type=script&setup=true&lang=js"

import "./UButton.vue?vue&type=style&index=0&id=4f3c5b2e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4f3c5b2e"]])

export default __exports__